exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".primary-button{background-color:#b6102f;border-radius:4px;color:white;border:none}.primary-button:hover,.primary-button:focus,.primary-button:active{background-color:#F62D53 !important;cursor:pointer !important;outline:none}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/sass-loader/dist/cjs.js!./src/Component/PrimaryButton.scss
// module id = 655
// module chunks = 0